import './observer';
import './captcha';
import './customelements';
import './eventbus';
import './filedroparea';
import './images';
import './localization';
import './price';
import './productfilter';
import './progress';
import './responseprocessor';
import './search';
import './validation';
import './views/cart';
import './views/category';
import './views/home';
import './views/shipping';
import './views/question';
import './views/watchdog';
import './views/newsletter';
import './views/import';

// Dynamick� odes�l�n� formul��u a na��t�n�m nov�ho renderu
window.submitApiForm = async function(form)
{
    var formData = {};

    for (const key in form.dataset)
    {
        if (key === "api" || key === "interactive" || key === "method" || key === "processor" || key === "captcha")
            continue;

        formData[key] = form.dataset[key];
    }

    if (form.dataset.interactive === "true")
    {
        form.querySelectorAll(":scope input, :scope select, :scope textarea").forEach(input =>
        {
            if (input.type == "radio" && !input.checked)
                return;

            var value = input.value;

            if (value == "true" || value == "false")
                value = value === "true" ? true : false;

            formData[input.name] = value;
        });
    }

    // recaptcha
    if (window.captcha && window.captcha.isEnabled() && window.captcha.shouldValidateForm(form))
        formData["captchaToken"] = await window.captcha.getTokenAsync(form.dataset);

    var url = form.getAttribute('action');
    var method = form.dataset.method ? form.dataset.method : form.getAttribute('method');
    var headers =
    {
        'Content-Type': 'application/json'
    };

    var eventTriggers = form.querySelectorAll(":scope event-trigger");

    progress.show();

    var data = null;

    try
    {
        var response = await fetch(url,
        {
            method: method,
            headers: headers,
            body: JSON.stringify(formData)
        });

        if (!response.ok)
        {
            if (window.captcha.isEnabled())
                await window.captcha.handleErrorAsync(response);

            throw new Error('Network response was not ok. Details: ' + response.text());
        }

        data = await response.json();

        var processor = form.dataset.processor
            ? window.responseFactory.getProcessorFromReference(form.dataset.processor)
            : window.responseFactory.getProcessorFromUrl(url);

        var processorResult = true;

        if (processor)
            processorResult = await processor.processAsync(data);

        if (!processorResult)
            throw new Error('Processor failed to process data.');
    }
    catch (error)
    {
        progress.hide();

        eventTriggers.forEach(eventTrigger =>
        {
            eventTrigger.trigger("OnFailed", error);
        });

        console.error('Error:', error);

        return;
    }

    var itemsToLoad = form.querySelectorAll(":scope load-data");
    var scriptsToRun = form.querySelectorAll(":scope run-script");

    eventTriggers.forEach(eventTrigger =>
    {
        eventTrigger.trigger("OnTrigger", formData);
    });

    itemsToLoad.forEach(itemToLoad =>
    {
        var query = "";
        var url = itemToLoad.dataset.url;

        //if (url.startsWith("/"))
        //    url = `${document.baseURI}${url.substring(1)}`;

        if (itemToLoad.dataset.query !== undefined)
            query = itemToLoad.dataset.query;

        fetch(url + query)
            .then(response => response.text())
            .then(html =>
            {
                var target = document.querySelector(itemToLoad.dataset.target);

                if (itemToLoad.dataset.targetType == "Parent")
                    target.innerHTML = html;
                else if (itemToLoad.dataset.targetType == "Self")
                    target.outerHTML = html;

                // je pot�eba znovu proj�t querySelector, jinak bude target.parentNode == null a inicializace abra prob�hne chybn�
                target = document.querySelector(itemToLoad.dataset.target);

                abra.init(target);

                var customEvent = new CustomEvent("onElementContentChanged", { detail: { target: itemToLoad.dataset.target, node: target } });

                document.dispatchEvent(customEvent);

                images.load();
            })
            .catch(error =>
            {
                console.error('Failed to load: ' + itemToLoad.dataset.url + " - ", error);
            });
    });

    scriptsToRun.forEach(scriptToRun =>
    {
        var functionToRun = new Function(scriptToRun.dataset.function);

        functionToRun();
    });

    progress.hide();

    eventTriggers.forEach(eventTrigger =>
    {
        eventTrigger.trigger("OnAjaxComplete", formData);
    });

    form.reset();

    validator.resetForm(form);
}

window.submitAjaxForm = async function(form)
{
    var formData = new FormData(form);

    // recaptcha
    if (window.captcha && window.captcha.isEnabled() && window.captcha.shouldValidateForm(form))
        formData.append("captchaToken", await window.captcha.getTokenAsync(form.dataset));

    var url = form.getAttribute('action');
    var method = form.getAttribute('method');
    var headers =
    {
        'X-Requested-With': 'XMLHttpRequest'
    };

    var eventTriggers = form.querySelectorAll(":scope event-trigger");

    progress.show();

    var data = null;

    try
    {
        const response = await fetch(url,
        {
            method: method,
            headers: headers,
            body: new URLSearchParams(formData) // x-www-form-urlencoded aby prob�hla spr�vna deserializace listu.. v p��pad� pot�eby m��eme implementovat multipart/form-data
        });

        if (!response.ok)
        {
            if (window.captcha.isEnabled())
                await window.captcha.handleErrorAsync(response);

            throw new Error('Network response was not ok.');
        }

        const contentType = response.headers.get("Content-Type");

        if (contentType && contentType.indexOf("application/json") !== -1)
            data = await response.json();
        else
            data = await response.text();
    }
    catch (error)
    {
        progress.hide();

        eventTriggers.forEach(eventTrigger =>
        {
            eventTrigger.trigger("OnFailed", error);
        });

        console.error('Error:', error);

        return;
    }

    eventTriggers.forEach(eventTrigger =>
    {
        eventTrigger.trigger("OnTrigger");
    });

    if (typeof data === "object")
    {
        for (var key in data)
        {
            if(!data.hasOwnProperty(key))
                continue;

            var tempDiv = document.createElement("div");
            tempDiv.innerHTML = data[key];

            var blockContainer = tempDiv.querySelector(":scope block-container");

            var targetSelector = null;

            if (blockContainer)
                targetSelector = blockContainer.dataset.containerSelector;

            if (targetSelector == null)
                continue;

            blockContainer.remove();

            var target = document.querySelector(targetSelector);

            if (target)
            {
                target.outerHTML = tempDiv.innerHTML;

                // je pot�eba znovu proj�t querySelector, jinak bude target.parentNode == null a inicializace abra prob�hne chybn�
                target = document.querySelector(targetSelector);

                abra.init(target);
            }
        }
    }

    if (typeof data === "string" && form.dataset.target)
    {
        var target = document.querySelector(form.dataset.target);

        target.outerHTML = data;

        // je pot�eba znovu proj�t querySelector, jinak bude target.parentNode == null a inicializace abra prob�hne chybn�
        target = document.querySelector(form.dataset.target);

        abra.init(target);

        var scriptsToRun = document.querySelectorAll("script[data-run]");

        scriptsToRun.forEach(scriptToRun =>
        {
            eval(scriptToRun.textContent);

            scriptToRun.removeAttribute("data-run");
        });
    }

    progress.hide();

    eventTriggers.forEach(eventTrigger =>
    {
        eventTrigger.trigger("OnAjaxComplete");
    });

    form.reset();

    validator.resetForm(form);

    images.load();
}

document.addEventListener("submit", async function (e)
{
    if (e.target.dataset.api === undefined)
        return;

    e.preventDefault();

    await submitApiForm(e.target);
});

// Input v ko��ku pro zm�nu mno�stv�
document.addEventListener("change", async function (e)
{
    if (e.target.dataset.cartQuantity !== undefined)
    {
        var form = e.target.closest("form");
        form.dataset.quantity = e.target.value;

        var eventListener = form.querySelector(":scope event-trigger[event='CartQuantityChanged']");

        if (eventListener)
            eventListener.dataset.quantity = parseFloat(e.target.value) - parseFloat(e.target.dataset.originalValue);

        await submitApiForm(form);
    }

    if (e.target.dataset.quantity !== undefined)
    {
        var form = e.target.closest("form");
        form.dataset.quantity = e.target.value;
    }
});

// Focus pro input mno�stv�
document.addEventListener("focus", function (e)
{
    if (e.target && e.target.matches("input[data-focus='select']"))
        e.target.select();
}, true);

// Utils
window.createCookie = function(name, value, days)
{
    var expires = "";

    if (days)
    {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

        expires = `; expires=${date.toGMTString()}`;
    }

    document.cookie = `${name}=${value}${expires}; path=/`;
}

window.readCookie = function(name)
{
    var nameEQ = `${name}=`;

    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++)
    {
        var c = ca[i];

        while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);

        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
    }

    return null;
}

window.eraseCookie = function(name)
{
    createCookie(name, "", -1);
}

window.abra =
{
    bindInteractiveForms: function (parentNode)
    {
        var interactiveForms = parentNode.querySelectorAll("form[data-interactive='true']");

        interactiveForms.forEach(interactiveForm =>
        {
            var submitButton = interactiveForm.querySelector(":scope button[type='submit']");

            var options =
            {
                disableButton: submitButton && submitButton.dataset.disable == "true"
            };

            validator.bindInteractiveForm(interactiveForm, options);
        });
    },
    bindDataClick: function (parentNode)
    {
        var buttons = parentNode.querySelectorAll("*[data-click]");

        buttons.forEach(button =>
        {
            button.addEventListener("click", function (e)
            {
                document.querySelector(button.dataset.click).click();
            });
        });
    },
    bindDataDropdownHover: function (parentNode)
    {
        // bindujeme zat�m jen pro menu
        if (parentNode !== document)
            return;

        var dropdowns = parentNode.querySelectorAll("*[data-dropdown-hover]");

        dropdowns.forEach(dropdown =>
        {
            var targetId = dropdown.dataset.dropdownHover;

            dropdown.addEventListener("mouseover", function (e)
            {
                var targetElement = document.getElementById(targetId);

                if (targetElement == null)
                    return;

                targetElement.click();
            });
        });
    },
    bindDataSubmit: function (parentNode)
    {
        var selectBoxes = parentNode.querySelectorAll("select[data-submit]");

        selectBoxes.forEach(selectBox =>
        {
            selectBox.addEventListener("change", function (e)
            {
                var form = selectBox.closest("form");

                form.submit();
            });
        });
    },
    bindDataSort: function (parentNode)
    {
        var buttons = parentNode.querySelectorAll("button[data-sort]");

        buttons.forEach(button =>
        {
            button.addEventListener("click", event =>
            {
                if (!button.dataset.target)
                    return;

                var target = document.querySelector(button.dataset.target);

                if (!target)
                    return;

                target.value = button.dataset.sort;

                if (button.dataset.submit == null)
                    return;

                target.closest("form").submit();
            });
        });
    },
    bindDataToggle: function (parentNode)
    {
        var toggleCheckboxs = parentNode.querySelectorAll("input[data-toggle]");

        toggleCheckboxs.forEach(toggleCheckbox =>
        {
            toggleCheckbox.addEventListener("change", function (e)
            {
                var targets = toggleCheckbox.dataset.toggle.split(",");

                targets.forEach(targetSelector =>
                {
                    var target = document.querySelector(targetSelector);

                    if (!target)
                        return;

                    if (target.classList.contains("d-none"))
                    {
                        target.classList.remove("d-none");
                        target.classList.add("d-block");
                    }
                    else
                    {
                        target.classList.remove("d-block");
                        target.classList.add("d-none");
                    }
                });
            });
        });
    },
    bindBootstrap: function (parentNode)
    {
        var modals = parentNode.querySelectorAll(".modal");

        if (parentNode.classList.contains("modal"))
        {
            var instance = bootstrap.Modal.getOrCreateInstance(parentNode);

            if (parentNode.classList.contains("show"))
            {
                document.querySelector(".modal-backdrop").remove();
                document.body.style.overflow = null;

                instance.show();
            }
        }

        if (modals)
        {
            modals.forEach(modal =>
            {
                var instance = bootstrap.Modal.getOrCreateInstance(modal);

                if (modal.classList.contains("show"))
                {
                    document.querySelector(".modal-backdrop").remove();
                    document.body.style.overflow = null;

                    instance.show();
                }
            });
        }

        var tooltip = document.body.querySelector(":scope .tooltip");

        if (tooltip)
            tooltip.remove();

        var tooltips = parentNode.querySelectorAll("*[data-bs-toggle='tooltip']");

        if (tooltips)
        {
            tooltips.forEach(tooltip =>
            {
                bootstrap.Tooltip.getOrCreateInstance(tooltip);
            });
        }
    },
    init: function (parentNode)
    {
        parentNode = parentNode || document;

        abra.bindInteractiveForms(parentNode);
        abra.bindDataClick(parentNode);
        abra.bindDataDropdownHover(parentNode);
        abra.bindDataSubmit(parentNode);
        abra.bindDataSort(parentNode);
        abra.bindDataToggle(parentNode);

        if (parentNode !== document)
            abra.bindBootstrap(parentNode);
    }
};

document.addEventListener("DOMContentLoaded", async function (e)
{
    images.load();
    localization.load();
    price.load();

    abra.init();
    filedroparea.init();
    search.init();
    cart.init();
    shipping.init();
    category.init();
    home.init();
});

//export default abra;